module.exports = __webpack_public_path__ + "static/img/feature_1.b84bfc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/drive/feature_1.png
// module id = AHBP
// module chunks = 0